import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import PublicHeader from "./PublicHeader";
import PublicFooter from "./PublicFooter";
import AgeGate from "./AgeGate";
import MobileCTABar from "./MobileCTABar";
import CosmicBackground from "@/components/lifted/CosmicBackground";
import { trackEvent } from "@/lib/retention";
import { useCaptureRef } from "@/lib/affiliateTracking";

export default function PublicShell() {
  useCaptureRef();
  // Fire a single home_view per session-load — pageview-style analytics.
  useEffect(() => {
    if (typeof window !== "undefined" && window.location.pathname === "/") {
      trackEvent("home_view");
    }
  }, []);

  return (
    <div className="min-h-screen flex flex-col relative overflow-x-hidden">
      <CosmicBackground />
      <AgeGate />
      <PublicHeader />
      <main className="flex-1 relative z-10 pb-20 md:pb-0 overflow-x-hidden">
        <Outlet />
      </main>
      <PublicFooter />
      <MobileCTABar />
    </div>
  );
}
